import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { map, catchError } from "rxjs/operators";
import { CookieService } from "ngx-cookie-service";
import { Contact, LogActivity } from '../models';
import { AppConfig } from '../Utilities/app-config.service';

import {convertToParamMap, ParamMap} from '@angular/router';
import { BehaviorSubject } from 'rxjs';

const routes = {
  users: "/users"
};

@Injectable({
  providedIn: "root"
})
export class FindCRSService {
  constructor(
    private apiService: ApiService,
    private cookieService: CookieService,
    public appConfig: AppConfig
  ) {}

  searchAgents(kwdName: string, kwdLocation: string, pageSize: any, memberNo = '') {

    kwdName = kwdName ? kwdName.trim() : "";
    kwdLocation = kwdLocation ? kwdLocation.trim() : "";
    memberNo = memberNo ? memberNo.trim() : "";
    let urlEndPoint = this.appConfig.GetUrl('searchAgent');
    urlEndPoint = urlEndPoint.toString().replace('PAGESZ', pageSize);
    urlEndPoint = urlEndPoint.toString().replace('KEYWORD', kwdName);
    urlEndPoint = urlEndPoint.toString().replace('LCN', kwdLocation);
    urlEndPoint = urlEndPoint.toString().replace('MEMBERNO', memberNo);
    return this.apiService.get(urlEndPoint);
  }

  getAgentDetail(id: number) {
    return this.apiService.get(this.appConfig.GetUrl('getAgentDetail') + id);
  }

  getSearchResultByPage(  
    page_id: number,
    page: number,
    sortByEntity: string = null,
    sortIsAsc: boolean = null,
    filters: object = null
  ) {
    // let url = this.appConfig.GetUrl('getAgentResult') + page_id + "/" + page;
    let urlEndPoint = this.appConfig.GetUrl('getAgentResult');
    urlEndPoint = urlEndPoint.toString().replace('PGID', page_id);
    urlEndPoint = urlEndPoint.toString().replace('PGNO', page);

    if (sortByEntity) {
      urlEndPoint = urlEndPoint.toString().replace('PGSORTBY', sortByEntity);
      urlEndPoint = urlEndPoint.toString().replace('PGSORTASC', sortIsAsc);
    } else {
      // urlEndPoint = urlEndPoint.split('&')[0] + urlEndPoint.split('&')[1];
      urlEndPoint = urlEndPoint.toString().replace('PGSORTBY', '');
      urlEndPoint = urlEndPoint.toString().replace('PGSORTASC', true);
    }

    return this.apiService.post(urlEndPoint, filters);
  }

  seachAutoComplete(
    kwd: string,
    maxSuggestion: number,
    by: string,
    getAllResult: boolean = true
  ) {
    return this.apiService
      .get(this.appConfig.GetUrl('getAgentSuggestion') + "/" + by + "?kwd=" + kwd + "&maxSuggestion=" + maxSuggestion)
      .pipe(
        map(response => {

          // // NOTE: Does something on response, Modify the response as you see fit.
          const returnResponse = [];

          if (response && response.length) {
            if (getAllResult) {
              return response;
            } else {
              response.forEach(element => {
                returnResponse.push(element.FullName);
              });
              return returnResponse;
            }
          } else {
            return [];
          }
        }),
        catchError(error => {
          return [];
        })
      );
  }


  seachAutoComplete_Location(
    kwd: string,
    maxSuggestion: number,
    by: string
  ) {
    return this.apiService
    .get(this.appConfig.GetUrl('getAgentSuggestion') + "/" + by + "?kwd=" + kwd + "&maxSuggestion=" + maxSuggestion)
      .pipe(
        map(response => {
          if (response) {
              return response;
          } else {
            return {};
          }
        }),
        catchError(error => {
          return [];
        })
      );
  }
}
